.FormControlHoriz {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: 20px;

  & label {
    display: inline;
  }
}

.FormControlVert {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
